<!-- <h4 class="dashboard">Dashboard Coming soon!</h4> -->
<div class="page-content">
  <div class="body-data">
    <h6>Welcome {{ name }} !</h6>
    <div class="mt-3">
      <div class="container-fluid">
        <div class="grid row">
          <div class="grey display-flex col-md-2">
            <img src="assets/svg/Total Revenue.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">
                {{
                statsData?.total_revenue
                | currency : "INR" : "symbol-narrow" : "1.2-2"
                }}
              </h6>
              <p class="regular">TOTAL REVENUE</p>
            </div>
          </div>
          <div class="grey display-flex col-md-3 ml-4">
            <img src="assets/svg/Total Orders.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">{{ statsData?.total_orders }}</h6>
              <p class="regular">TOTAL ORDERS</p>
            </div>
          </div>
          <div class="grey display-flex col ml-4">
            <img src="assets/svg/Total Revenue (this month).svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">
                {{
                statsData?.total_revenue_this_month
                | currency : "INR" : "symbol-narrow" : "1.2-2"
                }}
              </h6>
              <p class="regular">TOTAL REVENUE (THIS MONTH)</p>
            </div>
          </div>
          <div class="grey display-flex col-md-3 ml-4 flex-grow-1">
            <img src="assets/svg/Total Machines.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">{{ statsData?.total_machines }}</h6>
              <p class="regular">TOTAL MACHINES</p>
            </div>
          </div>
        </div>
        <div class="grid row mt-3">
          <div class="grey display-flex col-md-2 mr-4">
            <img src="assets/svg/Inquiries Received.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">{{ statsData?.total_inquiries }}</h6>
              <p class="regular">INQUIRIES RECIEVED</p>
            </div>
          </div>
          <div class="grey display-flex col-md-2 mr-4">
            <img src="assets/svg/Open RFQ.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">{{ statsData?.open_rfqs }}</h6>
              <p class="regular">OPEN RFQ</p>
            </div>
          </div>
          <div class="grey display-flex col mr-4">
            <img src="assets/svg/Orders Completed.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">
                {{ statsData?.completed_orders }}
              </h6>
              <p class="regular">ORDERS COMPLETED</p>
            </div>
          </div>
          <div class="grey display-flex col mr-4">
            <img src="assets/svg/Open Orders.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount semi-bold">{{ statsData?.open_orders }}</h6>
              <p class="regular">OPEN ORDERS</p>
            </div>
          </div>
          <div class="grey display-flex col-md-2 p-4 flex-grow-1">
            <img src="assets/svg/OTIF-Scorecard.svg" alt="" />
            <div class="pl-3">
              <h6 class="amount">{{ statsData?.scorecard }}</h6>
              <p class="mt-1">OTIF/SCORECARD</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- :########################### charts ########################## -->
    <h6 class="mt-3">Reports Overview</h6>
    <div class="mt-2">
      <div class="d-flex justify-content-between py-2">
        <mat-radio-group [(ngModel)]="selectedValue" (change)="onSelectionChange($event)">
          <mat-radio-button [ngClass]="{ active: selectedValue === 'currentYear' }" class="example-radio-button light" value="currentYear">
            <p class="mb-0">Current Year</p>
          </mat-radio-button>
          <mat-radio-button [ngClass]="{ active: selectedValue === 'currentMonth' }" class="example-radio-button light" value="currentMonth">
            <p class="mb-0 text-secondary">Current Month</p>
          </mat-radio-button>
          <mat-radio-button [ngClass]="{ active: selectedValue === 'currentWeek' }" class="example-radio-button light" value="currentWeek">
            <p class="mb-0 text-secondary">Current Week</p>
          </mat-radio-button>
          <mat-radio-button [ngClass]="{ active: selectedValue === 'last5Years' }" class="example-radio-button light" value="last5Years">
            <p class="mb-0 text-secondary">Last 5 Years</p>
          </mat-radio-button>
          <mat-radio-button [ngClass]="{ active: selectedValue === 'custom' }" class="example-radio-button light" value="custom">
            <p class="mb-0 text-secondary">Custom Date Range</p>
          </mat-radio-button>
        </mat-radio-group>
      </div>
      
      <div *ngIf="selectedValue === 'custom'" class="custom-date-range mt-3">
        <div class="d-flex align-items-center">
          <mat-form-field appearance="outline" floatLabel="auto" class="mr-2">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" (dateChange)="onDateChange()" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
      
          <mat-form-field appearance="outline" floatLabel="auto" class="mr-2">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" (dateChange)="onDateChange()" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
      
          <button mat-raised-button class="orange mb-3" *ngIf="startDate && endDate" (click)="onGoClick()">
            Go
          </button>
        </div>
      </div>
      
      <div class="row mt-3">
        <div class="col-md-4">
          <div class="border">
            <canvas id="dashboardEnquiriesChart" height="225"> </canvas>
          </div>
        </div>
        <div class="col-md-4">
          <div class="border">
            <canvas id="dashboardOrdersChart" height="225"> </canvas>
          </div>
        </div>
        <div class="col-md-4">
          <div class="border">
            <canvas id="dashboardRevenueChart" height="225"> </canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="content container-fluid mt-5">
      <h6 class="semi-bold mt-4">Welcome to Truventor !</h6>
      <h6 class="light">
        Truventor is your complete online manufacturing solution
      </h6>
      <div class="sub-content mt-5 row col-md-12">
        <div class="col-md-3 right-padding">
          <img src="assets/svg/Get Curated (1).svg" alt="" />
          <div class="row mr-0 ml-0">
            <div class="col-md-3 pl-0 pr-2">
              <img class="mt-2" src="assets/svg/Bullet marker.svg" alt="" />
            </div>
            <h6 class="medium mt-2 col-md-9 p-0" style="text-align: left">
              Get Curated Enquiry
            </h6>
          </div>
        </div>
        <div class="col-md-3">
          <img src="assets/svg/Get Working capital (1).svg" alt="" />
          <div class="row mr-0 ml-0">
            <div class="col-md-3 pl-0 pr-2">
              <img class="mt-2" src="assets/svg/Bullet marker.svg" alt="" />
            </div>
            <h6 class="medium mt-2 col-md-9 p-0" style="text-align: left">
              Get Working Capital
            </h6>
          </div>
        </div>
        <div class="col-md-3">
          <img src="assets/svg/Procure raw mt (1).svg" alt="" />
          <div class="row mr-0 ml-0">
            <div class="col-md-3 pl-0 pr-2">
              <img class="mt-2" src="assets/svg/Bullet marker.svg" alt="" />
            </div>
            <h6 class="medium mt-2 col-md-9 p-0" style="text-align: left">
              Procure Raw Material
            </h6>
          </div>
        </div>
        <div class="col-md-3">
          <img src="assets/svg/Start MFG (1) (1).svg" alt="" />
          <div class="row mr-0 ml-0">
            <div class="col-md-3 pl-0 pr-2">
              <img class="mt-2" src="assets/svg/Bullet marker.svg" alt="" />
            </div>
            <h6 class="medium mt-2 col-md-9 p-0" style="text-align: left">
              Start Manufacturing
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>